import { SlidesStateNames } from 'src/app/client/journey/router/slides-states';
import { Borrower } from 'src/app/client/journey/shared/models/deal-resources/borrower.model';
import { Contact } from 'src/app/client/journey/shared/models/deal-resources/contact.model';
import { ClientJourneyContext } from 'src/app/client/journey/shared/services/deal/client-journey-context';
import { ClientJourneyValidatorStoreBase } from 'src/app/client/journey/shared/validation/client-journey-validator-store-base';
import { ValidationGlobalStore } from 'src/app/utilities/validation/validation-global-store';
import { PepValidator } from './pep.validator';
import { ReferralContactValidator } from './referral-contact.validator';

export class SubmitValidationStore extends ClientJourneyValidatorStoreBase {
  static readonly globalStoreKey = 'ReferralValidationStore';

  constructor(
    globalStore: ValidationGlobalStore,
    clientJourneyContext: ClientJourneyContext,
  ) {
    super(globalStore, clientJourneyContext, SlidesStateNames.ReviewAndSubmit);

    this.getReferralContactValidator(
      clientJourneyContext.deal?.referral?.contact,
    );

    // Create pep disclosure validator for each borrower
    clientJourneyContext.deal.borrowers.forEach(borrower =>
      this.getPepValidator(borrower),
    );
  }

  public getReferralContactValidator(
    contact: Contact,
  ): ReferralContactValidator {
    let key = this.getReferralContactKey(contact);
    let validator = this.getValidator(key);
    if (!validator) {
      validator = new ReferralContactValidator(contact);
      this.addValidator(key, validator);
    }
    return validator as ReferralContactValidator;
  }

  public getPepValidator(borrower: Borrower): PepValidator {
    const key = this.getBorrowerPepKey(borrower);
    let validator = this.getValidator(key);
    if (!validator) {
      validator = new PepValidator(borrower.pepDisclosureModel);
      this.addValidator(key, validator);
    }
    return validator as PepValidator;
  }

  private getReferralContactKey(contact: Contact): string {
    let key = `referral_contact_${contact.id}`;
    return key;
  }

  private getBorrowerPepKey(borrower: Borrower): string {
    let key = `borrower_pep_${borrower.id}`;
    return key;
  }

  override dispose() {
    super.dispose();
  }
}
